import { Skeleton as MuiSkeleton } from '@mui/material';
import type { ReactElement } from 'react';

/**
 * Bloc d'attente a la forme du contenu (maquette « Squelette »).
 *
 * Il reserve la place de ce qui arrive, pour que la page ne saute pas a
 * l'affichage. Decoratif (`aria-hidden`) : l'etat de chargement s'annonce par
 * `LoadingState` ou par l'ecran, une seule fois, et non par vingt blocs gris
 * lus un a un.
 */
export interface SkeletonProps {
  readonly width?: number | string;
  readonly height?: number;
  /** Rayon : 6 pour une ligne de texte, 16 pour une carte entiere. */
  readonly radius?: number;
}

export const Skeleton = ({ width = '100%', height = 12, radius = 6 }: SkeletonProps): ReactElement => (
  <MuiSkeleton
    aria-hidden
    variant="rectangular"
    animation="wave"
    width={width}
    height={height}
    sx={{ borderRadius: `${String(radius)}px`, bgcolor: 'tokens.neutralSoft' }}
  />
);
